import parse from 'html-react-parser';
import { useState } from 'react';
import { DonatePopUp } from './DonatePopUp';

export function DonateCard({ donate, setDialog }) {
  const [hidden, setHidden] = useState(true);

  return <article className="donate-card">
    <img onClick={() => setHidden(!hidden)} style={{"cursor": "pointer"}} src={donate.image} alt={donate.title} draggable="false" />
    <h3>{donate.title}</h3>
    <div className="button donate-button" style={{"marginBottom": "10px"}} onClick={() => setHidden(!hidden)}>
      {hidden ? "Подробнее" : "Скрыть"}
    </div>
    {!hidden && <span className="donate-text">{parse(donate.description)}</span>}

    <div className="button donate-button" onClick={() => setDialog(<DonatePopUp donate={donate} setDialog={setDialog} />)}>
      Купить (
        {donate.oldCost > donate.cost && <><s className="donate-old-cost-text">{donate.oldCost}₽</s>{" "}</>}
        {donate.cost}₽)
    </div>
  </article>;
};